// react
import React from "react";

// images
import deviceUnavailableImage from "../../assets/device-unavailable.svg";

// react-router-dom
import { useNavigate } from "react-router-dom";

// styles
import useStyles from "./errorStyles";

// mui
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

// Error Message Component
const ErrorMessage = ({ message }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        columns={{ xs: 12 }}
        spacing={4}
      >
        <Grid item>
          <img
            src={deviceUnavailableImage}
            style={{ width: 120, marginTop: "50%" }}
            alt="Device Unavailable Logo"
          />
        </Grid>
        <Grid item>
          <div className={classes.ErrorText}>
            <p style={{ fontWeight: "bold", fontSize: 14 }}>{message}</p>
          </div>
        </Grid>
        <Grid item>
          <div>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              onClick={() => {
                navigate("/");
              }}
            >
              Back
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorMessage;
